export default "__VITE_PUBLIC_ASSET__26ce5f0d__"